import SysTable from "app/class/sys-table";

export const groupInheritedColumnOptions = (
    options: any[], targetTable: SysTable | null, tables: SysTable[],
    inheritedLabel: (origin: string) => string = (origin) => `Inherited from ${origin}`,
    tableLabel: (table: SysTable) => string = (table) => table.label || table.name,
) => options.map((option) => {
    const origin = tables.find((table) => table.id === (option.sys_table_id?.id || option.sys_table_id));
    const own = origin?.id === targetTable?.id;
    return { ...option, originGroup: origin ? (own ? tableLabel(origin) : inheritedLabel(tableLabel(origin))) : "" };
}).sort((left, right) => {
    const leftOwn = (left.sys_table_id?.id || left.sys_table_id) === targetTable?.id;
    const rightOwn = (right.sys_table_id?.id || right.sys_table_id) === targetTable?.id;
    if (leftOwn !== rightOwn) return leftOwn ? -1 : 1;
    const byOrder = Number(left.order ?? 0) - Number(right.order ?? 0);
    return byOrder || String(left.name || "").localeCompare(String(right.name || ""));
});
